/**
 * ChatButton Component
 * 
 * Button to toggle AI chat popup.
 * Shows unread indicator when there are new messages.
 */

import React from 'react';
import { useChat } from '../contexts/ChatContext';
import { Pulse } from './Animations';

function ChatButton() {
    const { toggleChat, isOpen } = useChat();

    return (
        <button
            onClick={toggleChat}
            className={`
        px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200
        flex items-center gap-2 relative
        ${isOpen
                    ? 'text-wine-400 bg-wine-500/10'
                    : 'text-gray-400 hover:text-gray-200 hover:bg-charcoal-950/50'
                }
      `}
            aria-label="Open Pleasance Guide"
            title="Pleasance Guide"
        >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>

            {/* Subtle glow when active */}
            {isOpen && (
                <Pulse className="absolute inset-0 rounded-lg bg-wine-500/10" />
            )}
        </button>
    );
}

export default ChatButton;
